"use client";

import React from "react";
import { Star, Play, ExternalLink } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const reviewsData = [{
  id: 1,
  rating: "5.0",
  quote: "“My\xA0body treatment was the most restorative experience I've had in years.”",
  author: "Elena R.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672390/img/spa_experience_elena.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672390/img/spa_experience_elena.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672390/img/spa_experience_elena.png-wvc-sizes",
    alt: "Elena relaxing in a serene spa environment"
  }
}, {
  id: 2,
  rating: "4.9",
  quote: "From the moment I walked in, the forest-inspired scents and professional care made me feel completely at peace. Highly recommended.",
  author: "Julian M.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672390/img/spa_experience_julian.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672390/img/spa_experience_julian.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672390/img/spa_experience_julian.png-wvc-sizes",
    alt: "Julian enjoying a peaceful moment post-treatment"
  }
}];
export default function CustomerReviews() {
  return <section data-section-id="258345" id="voices-of-serenity" className="py-24 dark bg-background text-foreground overflow-hidden transition-colors duration-300">
      <div className="container mx-auto px-4 md:px-6">
        <Carousel opts={{
        align: "start",
        loop: true
      }} className="w-full max-w-6xl mx-auto">
          <CarouselContent>
            {reviewsData.map((review, i) => <CarouselItem key={review.id} data-index={i}>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center">
                  <div className="flex flex-col justify-center">
                    <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight mb-6 flex items-start gap-3">
                      <div>
                        <span className="text-primary block mb-2 italic decoration-chart-2/50 underline-offset-8">Voices of</span>
                        <span className="text-chart-2 block decoration-primary/50 underline-offset-8">Serenity.</span>
                      </div>
                      <ExternalLink className="w-6 h-6 mt-2 text-muted-foreground opacity-0 transition-opacity" />
                    </h2>

                    <div className="mb-8">
                      <div className="flex items-center gap-2 mb-2">
                        <span className="text-xl font-semibold text-foreground">{review.rating}</span>
                        <div className="flex items-center">
                          {[...Array(5)].map((_, starIndex) => <Star key={starIndex} className="w-6 h-6 fill-chart-2 text-chart-2" />)}
                        </div>
                      </div>
                      
                    </div>

                    <div className="flex flex-wrap gap-4 mb-16">
                      <Button asChild size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground border-none rounded-lg px-8">
                        
                      </Button>
                      <Button asChild size="lg" className="bg-secondary hover:bg-secondary/90 text-secondary-foreground border-none rounded-lg px-8">
                        
                      </Button>
                    </div>

                    <div className="relative max-w-md mx-auto lg:mx-0 text-center">
                      <svg width="48" height="36" viewBox="0 0 48 36" fill="none" xmlns="http://www.w3.org/2000/svg" className="absolute -top-6 -left-8 text-chart-2/30 fill-current w-12 h-12 md:w-16 md:h-16">
                        <path d="M18 0L6 36H0L12 0H18ZM48 0L36 36H30L42 0H48Z" />
                      </svg>

                      <div className="px-8 py-4">
                        <p className="font-default font-bold text-chart-2 text-lg mb-2">
                          {review.author}&apos;s journey:
                        </p>
                        <p className="font-default italic text-foreground text-xl leading-relaxed">
                          &ldquo;{review.quote}&rdquo;
                        </p>
                      </div>

                      <svg width="48" height="36" viewBox="0 0 48 36" fill="none" xmlns="http://www.w3.org/2000/svg" className="absolute -bottom-6 -right-8 text-chart-2/30 fill-current w-12 h-12 md:w-16 md:h-16">
                        <path d="M18 0L6 36H0L12 0H18ZM48 0L36 36H30L42 0H48Z" />
                      </svg>
                    </div>
                  </div>

                  <div className="relative flex justify-center lg:justify-end mt-12 lg:mt-0">
                    <div className="relative w-full max-w-md aspect-[3/4] rounded-3xl overflow-hidden shadow-2xl">
                      <img src={review.image.src} data-wvc-srcset={review.image.srcset} data-wvc-sizes={review.image.sizes} alt={review.image.alt} className="w-full h-full object-cover grayscale-[20%] transition-all duration-700" loading="lazy" />
                      
                      
                    </div>

                    <div className="absolute -bottom-5 left-1/2 lg:left-auto lg:right-24 -translate-x-1/2 lg:translate-x-0 bg-chart-2 text-primary-foreground px-8 py-2.5 rounded-lg font-default font-medium text-lg shadow-lg">
                      {review.author}
                    </div>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>
          
          <div className="flex justify-center gap-4 mt-16 lg:mt-24">
            <CarouselPrevious className="static translate-y-0 translate-x-0 bg-secondary border-border hover:bg-accent hover:text-accent-foreground rounded-lg" />
            <CarouselNext className="static translate-y-0 translate-x-0 bg-secondary border-border hover:bg-accent hover:text-accent-foreground rounded-lg" />
          </div>
        </Carousel>
      </div>
    </section>;
}